import { Entry } from '../Entry'

export function Entry20230126() {
  return (
    <Entry title="26/01/2023 - v3.3.3">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13676/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
